var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import gql from 'graphql-tag';
import FilterList from './FilterList.vue';
import { BOLS, BOLS_AGG } from '@/queries/bols';
import { exportCsv } from '@/services/importExport';
import { whereQuery } from '@/services/sharedForm';
var DailyLogList = /** @class */ (function (_super) {
    __extends(DailyLogList, _super);
    function DailyLogList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.bols = [];
        _this.bols_aggregate = null;
        _this.offset = 0;
        _this.where = {};
        _this.pageNum = 1;
        _this.loading = true;
        _this.sortDir = 'desc';
        _this.errMsg = false;
        _this.csvExportLoading = false;
        _this.options = {
            showSilo: true,
            showLocation: true,
            showProduct: true,
            showSearch: true,
            showTimeframe: true,
            selectedTimeframe: 'Today',
            selectedSilo: {},
            selectedLocation: {},
            selectedProduct: {},
            searchQuery: '',
            selectedQuery: 'PO #',
            changeOptions: function () { return _this.filterChanged(); }
        };
        return _this;
    }
    DailyLogList.prototype.metaInfo = function () {
        return {
            title: 'Daily Log List'
        };
    };
    DailyLogList.prototype.mounted = function () {
        var storedOptions = {};
        if (typeof (Storage) !== "undefined") {
            storedOptions = JSON.parse(localStorage.getItem("bol_filters"));
        }
        this.options = Object.assign(this.options, storedOptions);
        this.where = whereQuery(this.options);
    };
    DailyLogList.prototype.beforeDestroy = function () {
        try {
            this.$apollo.subscriptions.bols.destroy();
            this.$apollo.subscriptions.bols_aggregate.destroy();
        }
        catch (e) { }
    };
    Object.defineProperty(DailyLogList.prototype, "selectedBol", {
        get: function () {
            return {};
        },
        set: function (val) {
            if (val.id) {
                this.$router.push({ name: 'Edit BOL', params: { id: val.id } });
            }
        },
        enumerable: true,
        configurable: true
    });
    DailyLogList.prototype.exportCsvData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.csvExportLoading = true;
                        return [4 /*yield*/, exportCsv(this.where, this.sortDir, 'Daily Log List.csv', true)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        this.$toast.open({
                            duration: 5000,
                            message: 'There was an error creating CSV file. Please try again.',
                            position: 'is-top',
                            type: 'is-warning'
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        this.csvExportLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DailyLogList.prototype.filterChanged = function () {
        if (typeof (Storage) !== "undefined") {
            localStorage.setItem("bol_filters", JSON.stringify(this.options));
        }
        this.loading = true;
        this.where = whereQuery(this.options);
    };
    DailyLogList.prototype.onSort = function (field, sort) {
        this.loading = true;
        this.sortDir = sort;
    };
    DailyLogList.prototype.pageChanged = function (currPage) {
        this.loading = true;
        var offset = ((currPage - 1) * 25) + 1;
        this.offset = offset >= 0 ? offset : 0;
    };
    DailyLogList = __decorate([
        Component({
            name: 'daily-log-list',
            components: {
                'filterList': FilterList
            },
            apollo: {
                bols: {
                    query: function () { return gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["query ", ""], ["query ", ""])), BOLS); },
                    variables: function () {
                        return {
                            offset: this.offset,
                            sort: this.sortDir,
                            where: this.where,
                        };
                    },
                    fetchPolicy: 'no-cache',
                    subscribeToMore: {
                        document: function () { return gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["subscription ", ""], ["subscription ", ""])), BOLS); },
                        variables: function () {
                            return {
                                offset: this.offset,
                                sort: this.sortDir,
                                where: this.where,
                            };
                        },
                        updateQuery: function (previousResult, _a) {
                            var subscriptionData = _a.subscriptionData;
                            return {
                                bols: subscriptionData.data.bols
                            };
                        }
                    },
                    result: function (_a) {
                        var data = _a.data;
                        this.loading = false;
                    }
                },
                bols_aggregate: {
                    query: function () { return gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["query ", ""], ["query ", ""])), BOLS_AGG); },
                    variables: function () {
                        return {
                            where: this.where,
                        };
                    },
                    fetchPolicy: 'no-cache',
                    subscribeToMore: {
                        document: function () { return gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["subscription ", ""], ["subscription ", ""])), BOLS_AGG); },
                        variables: function () {
                            return {
                                where: this.where,
                            };
                        },
                        updateQuery: function (previousResult, _a) {
                            var subscriptionData = _a.subscriptionData;
                            return {
                                bols_aggregate: subscriptionData.data.bols_aggregate
                            };
                        }
                    },
                }
            }
        })
    ], DailyLogList);
    return DailyLogList;
}(Vue));
export default DailyLogList;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/DailyLogList.vue
// module id = 780
// module chunks = 1